<div class="claim">
  <nz-card class="w-100%" [nzBordered]="false" [nzTitle]="overViewTitle">
    <div class="flex">
      <app-pie-chart
        [chartData]="chartData"
        [totalClaim]="totalClaim"
      ></app-pie-chart>
      <div class="claim-statistic">
        <div
          *ngFor="let data of chartData"
          class="statistic"
          [style.border-top]="'6px solid ' + data.color"
        >
          <div class="statistic-text">
            <p>{{ data.label }}</p>
            <p>{{ data.value }}</p>
          </div>
        </div>
      </div>
    </div>
  </nz-card>
  <nz-card class="w-100%" [nzBordered]="false" nzTitle="Claim List">
    <form [formGroup]="searchFormData">
      <div nz-row [nzGutter]="20">
        <div nz-col [nzSpan]="5">
          <nz-form-item class="search-form-item">
            <nz-form-label>Claim Number</nz-form-label>

            <nz-form-item>
              <nz-input-group>
                <input
                  class="h44"
                  formControlName="claimNumber"
                  nz-input
                  placeholder="Type in here..."
                />
              </nz-input-group>
            </nz-form-item>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="6">
          <nz-form-item class="search-form-item">
            <nz-form-label>Time Period</nz-form-label>

            <nz-range-picker
              class="w100 h44"
              [nzSuffixIcon]="suffixDate"
              [nzFormat]="dateFormat"
              formControlName="timePeriod"
            >
            </nz-range-picker>
            <ng-template #suffixDate><i class="search-date"></i></ng-template>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="5">
          <nz-form-item class="search-form-item">
            <nz-form-label>Claim Category</nz-form-label>

            <nz-form-item>
              <nz-input-group>
                <input
                  class="h44"
                  formControlName="claimCategory"
                  nz-input
                  placeholder="Type in here..."
                />
              </nz-input-group>
            </nz-form-item>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="6">
          <nz-form-item class="search-form-item">
            <nz-form-label>Active Approver</nz-form-label>

            <nz-form-item>
              <nz-input-group>
                <input
                  class="h44"
                  formControlName="activeApprover"
                  nz-input
                  placeholder="Type in here..."
                />
              </nz-input-group>
            </nz-form-item>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="2" class="button-link">
          <button nz-button nzType="link" (click)="handleSearch()">
            <span nz-icon nzType="search"></span> Search Adapt
          </button>
        </div>
      </div>
    </form>
    <nz-table
      #basicTable
      [nzData]="dataSource"
      [nzFrontPagination]="false"
      [nzShowTotal]="totalTemplate"
      nzShowSizeChanger
      nzShowPagination
      [nzTotal]="pagination.total"
      [nzPageIndex]="pagination.pageIndex"
      [nzPageSize]="pagination.pageSize"
      [nzPageSizeOptions]="pagination.pageSizeOptions"
      (nzPageIndexChange)="pageIndexChange($event)"
      (nzPageSizeChange)="pageSizeChange($event)"
    >
      <thead>
        <tr>
          <th
            [nzChecked]="checked"
            nzLabel="Select all"
            (nzCheckedChange)="onAllChecked($event)"
          ></th>
          <th *ngFor="let col of columns">{{ col.name }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td
            [nzChecked]="setOfCheckedId.has(data.id)"
            [nzLabel]="data.name"
            (nzCheckedChange)="onItemChecked(data.id, $event)"
          ></td>
          <td *ngFor="let col of columns">
            <ng-container>
              <div
                *ngIf="
                  col.key === 'claimStatus';
                  then ClaimStatusTemplate;
                  else OtherTemplate
                "
              ></div>
              <ng-template #ClaimStatusTemplate>
                <custom-tag
                  [content]="data.claimStatus"
                  [backgroundColor]="
                    getColorByStatus(data.claimStatus, true, false)
                  "
                  [fontColor]="getColorByStatus(data.claimStatus, false, false)"
                  [borderColor]="
                    getColorByStatus(data.claimStatus, false, true)
                  "
                ></custom-tag>
              </ng-template>
              <ng-template #OtherTemplate>
                <div
                  class="flex-between"
                  *ngIf="col.key === 'claimValue'"
                  class="w90 flex-between"
                >
                  <span class="boldValue">{{ data.claimValue }}</span>
                  <span>{{ data.currency }}</span>
                </div>
                <span *ngIf="col.key !== 'claimValue'">{{
                  data[col.key]
                }}</span>
              </ng-template>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #totalTemplate let-total>{{
      "TOTAL_ITEM" | translate : { total }
    }}</ng-template>
  </nz-card>
</div>
